export default __webpack_public_path__ + "3186524c660ffbf0f8419007d07c9ea2.svg";